module.exports = __webpack_public_path__ + "assets/img/btn-back-31cfee7d.png";